<template>
    <div class="totalizers" v-if="currentComponent">
        <component
            :is="currentComponent"
            ref="TotalizersComponent"
            :filters="filters"
        />
    </div>
</template>

<script>
export default {
    name: 'Totalizers',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/pages/main/components/totalizers/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        getTotalizers() {
            this.$refs.TotalizersComponent.getTotalizers();
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}

.totalizers {
    margin-top: 16px;
}
</style>
